import { Card, CardContent, Box, Typography } from "@mui/material";

export default function AccountCard({ title, children, edge = "both" }) {
  const shadow =
    edge === "left"
      ? "-4px 0 12px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.08)"
      : edge === "right"
      ? "4px 0 12px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.08)"
      : "0px 4px 12px rgba(0,0,0,0.12)";

  const isRight = edge === "right";

  return (
    <Card
      sx={{
        maxWidth: 420,
        height: "575px",
        textAlign: "center",
        boxShadow: shadow,
        zIndex: 10,

        border: "3px solid var(--color-green-strong)",


        borderTopLeftRadius: edge === "right" ? 0 : 8,
        borderBottomLeftRadius: edge === "right" ? 0 : 8,
        borderTopRightRadius: edge === "left" ? 0 : 8,
        borderBottomRightRadius: edge === "left" ? 0 : 8,


        borderRight:
          edge === "left" ? "none" : "3px solid var(--color-green-strong)",


        mx: "auto",

        "@media (max-width:600px)": {
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
          borderWidth: "2px",
          borderLeft: "2px solid var(--color-green-strong)",
          borderRight: "2px solid var(--color-green-strong)",
          borderRadius: 8,
        },
      }}
    >
      <CardContent
        sx={{
          height: "100%",
          p: { xs: 3, sm: 4 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: isRight ? "center" : "flex-start",
        }}
      >
        {!isRight && (
          <Box sx={{ mb: 2 }}>
            <a
              href="https://tensoai.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/tensoLogo.jpg"
                alt="TensoAI Logo"
                style={{ width: 64, height: 64 }}
              />
            </a>
          </Box>
        )}

        <Typography variant={isRight ? "h3" : "h2"}>
          {title}
        </Typography>

        {children}
      </CardContent>
    </Card>
  );
}
